// extracted by mini-css-extract-plugin
export default {"PopupWindow":"WindowContainer_PopupWindow__WDZl3","DragHeader":"WindowContainer_DragHeader__XI-C8","DraggingHeader":"WindowContainer_DraggingHeader__1A8N5"};